import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=65712b9b&scoped=true&"
import script from "./not-found.vue?vue&type=script&lang=js&"
export * from "./not-found.vue?vue&type=script&lang=js&"
import style0 from "./not-found.vue?vue&type=style&index=0&id=65712b9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65712b9b",
  null
  
)

export default component.exports